import React from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";

const OffCanvas = ({
  isOffcanvasOpen,
  title,
  body,
  toggleSaveChanges,
  directionOffCanvas,
  widthOffCanvas,
}) => {
  return (
    <Offcanvas
      isOpen={isOffcanvasOpen}
      toggle={toggleSaveChanges}
      direction={directionOffCanvas}
      // ✅ Responsive width: use prop on desktop, full width on mobile
      style={{ 
        width: widthOffCanvas,
        maxWidth: "100vw"
      }}
      className="offcanvas-responsive"
    >
      <OffcanvasHeader 
        toggle={toggleSaveChanges}
        className="d-flex align-items-center justify-content-between py-3 px-3 px-md-4"
        style={{ 
          borderBottom: "1px solid #eee",
          minHeight: "60px"
        }}
      >
        {/* ✅ Responsive title with truncation */}
        <h5 
          className="mb-0 fw-semibold text-truncate"
          style={{ 
            fontSize: "16px",
            lineHeight: "1.4",
            maxWidth: "85%"
          }}
        >
          {title}
        </h5>
      </OffcanvasHeader>
      
      <OffcanvasBody className="p-3 p-md-4">
        {/* ✅ Wrap body in responsive container */}
        <div className="offcanvas-body-responsive">
          {body}
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default OffCanvas;